import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
// core
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
// components
import Pagination from '../../components/Pagination';

import useStyles from './styles';
import { translateIssue } from './issues';

const ROWS_PER_PAGE = 10;

const issueShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  params: PropTypes.object,
});

const COLUMNS = [
  'rowNumber',
  'project',
  'survey',
  'user',
  'location',
  'category',
  'productGroup',
  'expectedLocationResponses',
  'resetScale',
];

function ValidationTable({ rows }) {
  const styles = useStyles();
  const { t } = useTranslation();
  const [page, setPage] = useState(0);

  // Al subir un archivo nuevo se vuelve a la primera página.
  useEffect(() => {
    setPage(0);
  }, [rows]);

  const paginatedRows = rows.slice(page * ROWS_PER_PAGE, page * ROWS_PER_PAGE + ROWS_PER_PAGE);

  return (
    <Paper className={styles.tablePaper}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {COLUMNS.map((column) => (
                <TableCell key={column} className={styles.tableHeader}>
                  {t(`bulkAssociation.table.headers.${column}`)}
                </TableCell>
              ))}
              <TableCell className={styles.tableHeader}>
                {t('bulkAssociation.table.headers.status')}
              </TableCell>
              <TableCell className={styles.tableHeader}>
                {t('bulkAssociation.table.headers.detail')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={COLUMNS.length + 2} align="center">
                  {t('bulkAssociation.table.empty')}
                </TableCell>
              </TableRow>
            ) : paginatedRows.map((row) => (
              <TableRow hover key={row.rowNumber}>
                {COLUMNS.map((column) => (
                  <TableCell key={column}>{row[column]}</TableCell>
                ))}
                <TableCell
                  className={clsx(styles.status, {
                    [styles.validStatus]: row.valid,
                    [styles.invalidStatus]: !row.valid,
                  })}
                >
                  {row.valid
                    ? t('bulkAssociation.table.status.valid')
                    : t('bulkAssociation.table.status.invalid')}
                </TableCell>
                <TableCell>
                  {[...row.errors, ...(row.warnings || [])]
                    .map((issue) => translateIssue(t, issue))
                    .join('. ')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {rows.length > 0 && (
        <Pagination
          setPage={setPage}
          page={page}
          rowsPerPage={ROWS_PER_PAGE}
          quantity={rows.length}
        />
      )}
    </Paper>
  );
}

ValidationTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    rowNumber: PropTypes.number.isRequired,
    valid: PropTypes.bool.isRequired,
    load: PropTypes.bool.isRequired,
    errors: PropTypes.arrayOf(issueShape).isRequired,
    warnings: PropTypes.arrayOf(issueShape),
  })).isRequired,
};

export default ValidationTable;
